import { render } from "./AsideEstacaoSimples.vue?vue&type=template&id=e9f63be0"
import script from "./AsideEstacaoSimples.vue?vue&type=script&lang=js"
export * from "./AsideEstacaoSimples.vue?vue&type=script&lang=js"

import "./AsideEstacaoSimples.vue?vue&type=style&index=0&id=e9f63be0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__